

export default function CheckOnlinePaymentStatus(paymentStatus) {

    if(paymentStatus == 0){
        return "Pending"
    }
    else if(paymentStatus == 1){
        return "Initialized"
    }
    else if(paymentStatus == 2){
        return "Success"
    }
    else if(paymentStatus == 3){
        return "Failed"
    }
    else if(paymentStatus == 4){
        return "Cancelled"
    }
    else if(paymentStatus == 5){
        return "Declined"
    }
    else if(paymentStatus == 6){
        return "Not Applicable"
    }
    else{
        return "Failed by time out"
    }

}

const PHONEPAY_PAYMENT_STATUS = Object.freeze({
  PENDING: 0,
  INITIALIZED: 1,
  SUCCESS: 2,
  FAILED: 3,
  CANCELLED: 4,
  DECLINED: 5,
  NOT_APPLICABLE: 6,
  FAILED_TIMED_OUT: 7
})

